import {
  ViewChild,
  OnInit,
  Component,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { ValidatorService } from "../../services/validator.service";
import { NgForm } from "@angular/forms";
import { DadosFundoComponent } from "../dados-fundo/dados-fundo.component";
import { TicketService } from "../../services/ticket.service";
import { Subject } from "rxjs";
import { BankService } from "../../services/bank.service";

@Component({
  selector: "app-out-custody",
  templateUrl: "./out-custody.component.html",
  styleUrls: ["./out-custody.component.scss"],
})
export class OutCustodyComponent implements OnInit {
  constructor(
    private service: TicketService,
    private bankService: BankService
  ) {}

  outCustody: boolean;

  banksSettlementList: string[] = null;

  ngOnInit() {
    this.getListBanksSettlement();
    this.isOutCustody();
  }

  getListBanksSettlement() {
    this.service.getListBanksSettlement().subscribe((b) => {
      this.banksSettlementList = b;
    });
  }

  isOutCustody() {
    this.bankService.getBank().subscribe((value) => {
      if (
        value === null ||
        this.banksSettlementList === null ||
        this.banksSettlementList.includes(value)
      ) {
        this.outCustody = false;
      } else {
        this.outCustody = true;
      }
    });
  }
}
